import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ChooseCategory from "./ChooseCategory";
import Spinner from "react-bootstrap/Spinner";
import InputGroup from "react-bootstrap/InputGroup";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { deleteComment, updateComment } from "../../utils/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";

const AdminRow = ({
	comment,
	commentIndex,
	weekNumbers,
	categories,
	year,
	setUpdatedValue,
	comments,
	setComments,
}) => {
	// State to manage the loading state while submitting
	const [loading, setLoading] = useState(false);

	// Function to handle change in comment input
	const handleCommentChange = async (id, index, value) => {
		const updatedComments = [...comments];
		updatedComments[index].comment = value;
		setComments(updatedComments);
	};

	// Function to handle blur event on comment input
	const handleCommentBlur = async (id, index, value) => {
		try {
			setLoading(true); // Set loading state to true while submitting
			await updateComment(id, value);
		} catch (error) {
			// Handle error
		}

		setLoading(false); // Set loading state to false after submission
	};

	// Function to handle delete operation for a comment
	const handleDelete = async (id, index) => {
		if (window.confirm("Are you sure you want to delete this record?")) {
			try {
				const success = await deleteComment(id);
				if (success) {
					const updatedComments = comments.filter(
						(comment) => comment.id !== id
					);
					setComments(updatedComments);
				}
			} catch (error) {
				// Handle error
			}
		}
	};

	return (
		<>
			<tr key={comment.id}>
				<td>
					<InputGroup
						className={"form-control first-column border-0 p-0"}
					>
						<Form.Control
							id={'comment_' + comment.id}
							value={comment.comment}
							onChange={(e) =>
								handleCommentChange(
									comment.id,
									commentIndex,
									e.target.value
								)
							}
							onBlur={(e) =>
								handleCommentBlur(
									comment.id,
									commentIndex,
									e.target.value
								)
							}
						/>
						{loading && (
							<InputGroup.Text>
								<Spinner
									animation="border"
									variant="primary"
									size="sm"
								/>
							</InputGroup.Text>
						)}
					</InputGroup>
				</td>
				{weekNumbers.map((weekNumber, weekIndex) => (
					<ChooseCategory
						key={weekIndex}
						comment={comment}
						categories={categories}
						year={year}
						weekNumber={weekNumber}
						setUpdatedValue={setUpdatedValue}
					/>
				))}
				<td>
					<Button
						variant="link"
						className={"px-2 add-comment-button"}
						onClick={(e) => handleDelete(comment.id, commentIndex)}
					>
						<FontAwesomeIcon icon={faTrash} />
					</Button>
				</td>
			</tr>
		</>
	);
};

export default AdminRow;
